import Vue from 'vue'
import { Message } from 'element-ui'
import md5 from './md5'
import qs from 'qs'
import axios from 'axios'
// Vue.use(Message);
Vue.prototype.$message = Message

class http {
  constructor() {
    this.instance = axios.create()
    this.instance.interceptors.request.use(
      config => {
        config.headers.videotoken = sessionStorage.getItem('token')
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )
  }

  /**
   * 登录
   */
  login(phone, password) {
    return this._post('/video/user/login', {
      phone,
      password
    })
  }

  /**
   * 退出登录
   */
  loginOut() {
    return this._post('/video/user/logout')
  }

  /**
   * 入口和出口门
   * @param {*} mkid
   * @returns
   */
  enterOutDoor(shop_id, door_id) {
    return this._post('/video/shop/door', {
      shop_id,
      door_id
    })
  }

  /**
   * 锁店和解锁
   */
  lockAndUnLockShopApi(shop_id, shop_lock) {
    return this._post('/video/shop/lock', {
      shop_id,
      shop_lock
    })
  }

  /**
   * 获取所有店铺
   */
  getAllShopListApi(params) {
    return this._post('/video/shop/list', params)
  }

  /**
   * 根据id获取视频链接
   */
  getVideoByIdApi(shop_id, user_id) {
    return this._post('/video/hik/shop', { shop_id, user_id })
  }

  /**
   * 云眸token获取
   * @returns
   */
  getYunToken() {
    return this._post('/video/hik/account')
  }

  /**
   * 添加异常订单
   *
   */
  addAbnormalOrder(order_no, remark) {
    return this._post('/video/order/remark', { order_no, remark })
  }

  /**
   * 加入黑名单
   */
  addBlackList(data) {
    return this._post('/video/shop/black', data)
  }
  /**
   * 获取黑名单原因
   */
  getBlackBecauseApi(phone) {
    return this._post('/video/shop/reason', { phone })
  }
  /**
   * 移出黑名单
   */
  removeBlackApi(phone) {
    return this._post('/video/shop/removeBlack', { phone })
  }
  /**
   * 接单(暂时不使用)
   */
  orderTaking(order_no) {
    return this._post('/video/order/accept', { order_no })
  }

  /**
   * 客服在线列表
   *
   */
  customerServiceOnline(data) {
    return this._post('/video/customer/online', data)
  }

  /**
   * 视频分享
   */
  shareVideo(data) {
    return this._post('/video/customer/share', { data })
  }

  /**
   * 在线用户接单量
   */
  receptOrder(data) {
    return this._post('/video/user/recept', data)
  }

  //异常商品列表
  goodsNotice(data) {
    return this._post('/video/goods/list', data)
  }

  /**
   * /video/order/door
   */
  clickToAcceptOrder(visitorList) {
    return this._post('/video/order/door', { visitor_id: visitorList })
  }

  offlineShop() {
    return this._post('/video/hik/offline')
  }

  // 私有方法，用于发送 POST 请求
  _post(url, data) {
    return this.instance.post(url, data)
  }

  //
  _get(url, data) {
    return this.instance.get(url, data)
  }
}

export default new http()



// WEBPACK FOOTER //
// ./src/util/httplist.js